import { Layer } from '@deck.gl/core';
import { IFlightItem } from '../flights/types';
import { DeckLayerCreator } from './deck-layer-creator';
import { DeckOverlayPlugin } from './deck-overlay-plugin';
import { CoastComputeLayer } from './layers/flight/coast/coast-compute-layer';
import { CoastMode } from './types';

export class DeckCoast extends DeckLayerCreator {
    constructor(plugin: DeckOverlayPlugin) {
        super(plugin);
    }

    createLayers(data: IFlightItem[]): Layer[] {
        return [
            new CoastComputeLayer({
                id: 'coast-simulation',
                data,
                getId: (x) => x.id,
                getToPosition: (x) => x.coastToPosition ?? [0, 0, 0],
                getToTime: (x) => (x.coastToTime ? x.coastToTime - this.plugin.flightsUpdater.coastOffset : 0),
                getFromPosition: (x) => x.coastFromPosition ?? [0, 0, 0],
                getFromTime: (x) => (x.coastFromTime ? x.coastFromTime - this.plugin.flightsUpdater.coastOffset : 0),
                getProjectFromPosition: (x) => this.getFlightPosition(x),
                getProjectSpeed: (x) => this.getFlightSpeed(x),
                getProjectHeading: (x) => this.getFlightHeading(x) ?? 0,
                getProjectLastUpdateTime: (x) => this.getFlightLastReportTime(x), // unix seconds
                getMode: (x) => {
                    if (isAsdxFeed(this.getFlightFeedId(x)) && !x.onGround && (x.altitude ?? 0) > 0) {
                        if (x.coastFromPosition && x.coastToPosition && x.coastToTime !== null && x.coastFromTime !== null) {
                            return CoastMode.toTarget;
                        }
                    } else if (this.getFlightHeading(x) !== null && (this.getFlightSpeed(x) ?? 0) > 30) {
                        // Project into the future only the aircraft that have a heading and are >30kts. The later check is so that on ground aircraft that have some non zero but low speed from ADS-B are not coasted from the gate into nowhere
                        return CoastMode.project;
                    }
                    return CoastMode.noCoast;
                },
                minToTargetJump: this.plugin.deckCoastDebugProps.minToTargetJump,
                maxToTargetJump: this.plugin.deckCoastDebugProps.maxToTargetJump,
                unixOffsetSeconds: this.plugin.flightsUpdater.coastOffset,
                maxProjectTimeSeconds: this.plugin.deckCoastDebugProps.maxProjectForwardTimeSeconds,
                targetMode: this.plugin.deckCoastDebugProps.coastTargetMode,
                onPositionTextureChanged: (texture) => this.plugin.setPositionTexture(texture),
                updateTriggers: {
                    all: [this.flightsVersion, this.propsVersion],
                    getProjectFromPosition: this.getPositionUpdateTrigger,
                    getProjectSpeed: this.getPositionUpdateTrigger,
                    getProjectHeading: this.getPositionUpdateTrigger,
                    getProjectLastUpdateTime: this.getPositionUpdateTrigger,
                    getMode: this.getPositionUpdateTrigger
                }
            })
        ];
    }
}

function isAsdxFeed(feedId: number | null): boolean {
    return feedId !== null && feedId >= 200 && feedId <= 250;
}
